import React from "react";
import Typewriter from "typewriter-effect";
import HumanLogo from "../assets/LogoHuman.png";
import styles from "../styles/home.module.css";

function Home() {

  const signaxLogoClicked = () => {
    window.open("https://signa-x.io", "_blank");
  }

  const humanLogoClicked = () => {
    window.open("https://humanprotocol.org", "_blank");
  }

  return (
    <div className={styles["landing-container"]}>
      <div className={styles["float-nav"]}>
        <div className={styles["float-nav-right"]}>
          <img
            src="https://asset-signax.b-cdn.net/Signa%20X%20Black.png"
            alt="signaxlogo"
            style={window.innerWidth <= 760 ? {marginTop: "0px"} : {marginTop: "-5px"}}
            onClick={signaxLogoClicked}
          />
        </div>
        <div className={styles["float-nav-right"]}>
          <img src={HumanLogo} alt="signaxlogo" onClick={humanLogoClicked} style={window.innerWidth <= 760 ? {marginTop: "0px"} : {marginTop: "0px"}}/>
        </div>
      </div>
      <div className={`${styles["section-title"]} ${styles["ypewriter"]}`}>
        <Typewriter
          options={{
            strings: ["Challenge X"],
            autoStart: true,
            loop: true,
          }}
        ></Typewriter>
        <p>A gaming challenge creation platform for Web3</p>
      </div>
    </div>
  );
}
export default Home;
